// Origin patterns shared by the browser env config and the edge dd-logs proxy.
// Kept window-free so the edge runtime can import it without evaluating the
// browser-only environment module.

// Vercel preview deployments use dynamic subdomains like oath-admin-<hash>-<team> and oath-admin-git-<branch>-<team>.
export const VERCEL_PREVIEW_ORIGIN_RE = /^https:\/\/oath-admin-.+\.vercel\.app$/;
